export default __webpack_public_path__ + "static/media/manual-icon-active.fa74c63e.svg";